import { createContext, useContext } from 'react';

export type MimSidekickChat = {
  chatId: string;
  startNewChat: () => void;
  selectChat: (chatId: string) => void;
};

const MimSidekickChatContext = createContext<MimSidekickChat | null>(null);

export const MimSidekickChatProvider = MimSidekickChatContext.Provider;

/** Reads the active chat session and the ways to switch it. */
export const useMimSidekickChat = (): MimSidekickChat => {
  const context = useContext(MimSidekickChatContext);
  if (!context) {
    throw new Error(
      'useMimSidekickChat must be used within a MimSidekickChatProvider',
    );
  }
  return context;
};
